import axios from '@src/utils/axios'

const module = 'user_signup'
const axiosInstance = axios(false);

export default {
  'getIndustry': () => axiosInstance.get(`/${module}/get-industry`),
  'getCandidateSource': () => axiosInstance.get(`/${module}/get-candidate-source`),
  'getFunction': () => axiosInstance.get(`/${module}/get-function`),
  'getBrand': () => axiosInstance.get(`/${module}/get-brand`),

  'create': (ctx, data) => axiosInstance.post(`${module}/create-user`, data),
  'check_recruiter': (ctx, data) => axiosInstance.get(`/${module}/check-recruiter`,{params:data}),


}